// extracted by mini-css-extract-plugin
export default {"provisionalBadge":"provisionalBadge---gUNa_"};